module.exports = __webpack_public_path__ + "img/header-engagementRingsModern@2x.18e07d9.jpg";